import React from 'react'

import { cn } from './lib/utils'

interface DividerProps {
  name?: string
  className?: string
}

const Divider: React.FC<DividerProps> = ({ className }: DividerProps) => {
  return <div className={cn('my-5 h-0 w-full border-b', className)}></div>
}

export { Divider }
